import axios from "axios";

// const GIDEX_BASE_URL = "https://gidexstage.ginox.io";
const GIDEX_BASE_URL = process.env.REACT_APP_GIDEX_API_URL;
const ADMIN_KEY = process.env.REACT_APP_OMNISERVE_KEY;

const gidexInstance = axios.create({
  baseURL: GIDEX_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-admin-key": ADMIN_KEY,
  },
});

// GET /api/v1/admin/web3/config - Get all Web3 Configs
export const getWeb3Config = () =>
  gidexInstance.get("/api/v1/admin/web3/config");

// GET /api/v1/admin/web3/config/{provider} - Get config for specific provider
export const getWeb3ConfigByProvider = (provider) =>
  gidexInstance.get(`/api/v1/admin/web3/config/${provider}`);

// PUT /api/v1/admin/web3/config/{provider} - Update Web3 Config for specific provider
export const updateWeb3Config = (provider, data) =>
  gidexInstance.put(`/api/v1/admin/web3/config/${provider}`, data);

// GET /api/v1/admin/web3/lifi/withdraw/{chainId} - Get LiFi withdrawal transaction
export const getLifiWithdraw = (chainId) =>
  gidexInstance.get(`/api/v1/admin/web3/lifi/withdraw/${chainId}`);

// GET /api/v1/admin/web3/lifi/fees - Get LiFi collected fees across all chains
export const getLifiFees = () =>
  gidexInstance.get("/api/v1/admin/web3/lifi/fees");

export default gidexInstance;
